import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  uploadFile: {
    defaultMessage: 'Upload File',
    id: 'ydEp1y',
    description: 'Header Text for the user to upload a file in order import CSV',
  },
  helpContentText: {
    defaultMessage:
      'Upload a CSV file to import orders into a manual store. Need help formatting? <file>Download our sample CSV file</file> or <helpLink>learn more about importing a CSV</helpLink>.',
    id: 'T5db0g',
    description: 'Text to inform user about how to upload a CSV for order import',
  },
  uploadFileStepText: {
    defaultMessage: 'Upload File',
    id: 'ZeQr75',
    description: 'Text for each individual step of order import CSV',
  },
  createNewManualStore: {
    defaultMessage: 'Create New Manual Store',
    id: 'H49/5V',
    description: 'Create New Manual Store for order import CSV',
  },
  continueBtn: {
    defaultMessage: 'Upload & Preview',
    id: 'M1PAPD',
    description: 'Text on continue button',
  },
});
